import React from 'react'
import Edit from '../crud/edit'
import FieldList from '../fieldList'

const FieldBreakdown = ({ value, errorText, onChange, resource, ...props }) => {
  const handleFieldChange = (field, e, fieldValue) => {
    const updatedValue = Object.assign({}, value, {
      [field.prop]: fieldValue
    })

    onChange(e, updatedValue)
  }

  return (
    <div>
      {errorText && <p style={{ color: 'red' }}>All fields are required</p>}

      <FieldList
        resource={value || {}}
        errors={errorText || {}}
        onChange={handleFieldChange}
        {...props}
      />
    </div>
  )
}

const invoiceAddressMappingFields = [
  {
    name: 'Company Name',
    prop: 'companyName',
    type: 'text'
  },
  {
    name: 'Line 1',
    prop: 'line1',
    type: 'text'
  },
  {
    name: 'Line 2',
    prop: 'line2',
    type: 'text'
  }
]

const fields = [
  {
    name: 'InvoiceAddress',
    prop: 'value',
    type: 'component',
    component: FieldBreakdown,
    componentProps: {
      fields: invoiceAddressMappingFields
    }
  }
]

const EditSettings = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit Invoice Address'
      fields={fields}
      apiPath='admin/settings/invoice_address'
      successRedirectPath='/settings'
      buildMenuItems={() => {}}
      disableDelete
    />
  )
}

export default EditSettings
